module.exports = __webpack_public_path__ + "2366fffad0e8e7fc99fee65ec17bd241.gif";